// import { useState } from 'react'
import { useTranslation } from 'react-i18next'

// local imports
import { IFilteredGymSalonList } from 'types/GymType'
import {
  ReservationButton,
  GymSalonName,
  SalonLocation,
  Summary,
  StyledCard,
  CardHeaderOverlay,
  SalonCapacity,
  // FavoriteContainer,
} from '../styled'
// import GymService from 'service/GymService'
// import FavoriteIconButton from 'components/ui/FavoriteIconButton'

interface ComponentProps {
  showCapacity: boolean
  salon: IFilteredGymSalonList
  openModal: (salon: IFilteredGymSalonList) => void
}

export default function GymPersonalCard({ showCapacity, salon, openModal }: ComponentProps) {
  const { t } = useTranslation()
  /* ######### Gym Salon Data Destructuring ######### */
  const {
    // Id,
    name,
    gymSaloonInventories,
    reservationAndCapacityStr,
    // IsFavorite,
    floor: { name: floorName, locationName, districtName, cityName, countryName, blockName },
  } = salon || {}

  /* Location String */
  const location = `${locationName}, ${districtName}, ${cityName}, ${countryName}, ${blockName}, ${floorName}`
  const salonInventories = gymSaloonInventories?.map((si) => `${si.gymSaloonInventoryTypeName} (${si.amount})`)

  const openSearchModal = () => openModal(salon)

  // /* Favorite Gym Saloon */
  // const [favorite, setFavorite] = useState(IsFavorite)
  // const handleAddFavorite = () => {
  //   GymService.addGymSaloonFavorite(Id).then((r) => setFavorite(true))
  // }
  // const handleRemoveFavorite = () => {
  //   GymService.removeGymSaloonFavorite(Id).then((r) => setFavorite(false))
  // }

  return (
    <StyledCard>
      <CardHeaderOverlay>
        {/* <FavoriteContainer>
          <FavoriteIconButton onSave={handleAddFavorite} onRemove={handleRemoveFavorite} isFavorite={favorite} />
        </FavoriteContainer> */}
      </CardHeaderOverlay>

      <div className="d-flex flex-column align-items-center flex-grow-1 px-3">
        <div className="d-flex flex-column align-items-center text-center flex-grow-1">
          <GymSalonName>{`${name}`}</GymSalonName>
          <SalonLocation>{location}</SalonLocation>
          {showCapacity ? (
            <SalonCapacity>
              <i className="pi pi-users"></i>
              <span>{reservationAndCapacityStr}</span>
            </SalonCapacity>
          ) : null}

          {!!(salonInventories?.length) && (
            <Summary>
              {salonInventories.map((si, i) => (
                <p key={i}>{si}</p>
              ))}
            </Summary>
          )}
        </div>

        <ReservationButton onClick={openSearchModal}>{t('buttons.book-reservation')}</ReservationButton>
      </div>
    </StyledCard>
  )
}
